"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var ItemElement =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(ItemElement, _React$Component);

  function ItemElement(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ItemElement);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ItemElement).call(this, props));
    var content = _this.props.content;
    _this.state = {
      currentContent: _this.contentExceedsCharLimit() ? _this.getShortenedText() : content,
      buttonText: 'See More'
    };
    _this.expandOrContractLongText = _this.expandOrContractLongText.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ItemElement, [{
    key: "getShortenedText",
    value: function getShortenedText() {
      var _this$props = this.props,
          content = _this$props.content,
          charLimit = _this$props.charLimit;
      return content.substr(0, content.lastIndexOf(' ', charLimit)).concat('...');
    }
  }, {
    key: "contentExceedsCharLimit",
    value: function contentExceedsCharLimit() {
      var _this$props2 = this.props,
          content = _this$props2.content,
          charLimit = _this$props2.charLimit;
      return !(!content || content.length <= charLimit);
    }
  }, {
    key: "expandOrContractLongText",
    value: function expandOrContractLongText() {
      var content = this.props.content;
      var buttonText = this.state.buttonText;

      if (buttonText === 'See More') {
        this.setState({
          currentContent: content,
          buttonText: 'See Less'
        });
      }

      if (buttonText === 'See Less') {
        this.setState({
          currentContent: this.getShortenedText(),
          buttonText: 'See More'
        });
      }
    }
  }, {
    key: "renderCard",
    value: function renderCard() {
      var _this$props3 = this.props,
          buttonSize = _this$props3.buttonSize,
          buttonBasic = _this$props3.buttonBasic,
          buttonColor = _this$props3.buttonColor,
          imageCircular = _this$props3.imageCircular,
          imageSize = _this$props3.imageSize,
          itemCenterContent = _this$props3.itemCenterContent,
          link = _this$props3.link,
          linkAs = _this$props3.linkAs,
          header = _this$props3.header,
          headerIcon = _this$props3.headerIcon,
          image = _this$props3.image,
          subheader = _this$props3.subheader,
          cardInlinePhoto = _this$props3.cardInlinePhoto;
      var asLink = linkAs === 'header' && link;
      var _this$state = this.state,
          currentContent = _this$state.currentContent,
          buttonText = _this$state.buttonText;
      return _react["default"].createElement(_semanticUiReact.Card, {
        fluid: true
      }, !cardInlinePhoto && image && _react["default"].createElement(_semanticUiReact.Image, {
        src: image,
        fluid: true
      }), _react["default"].createElement(_semanticUiReact.Card.Content, null, cardInlinePhoto && image && _react["default"].createElement(_semanticUiReact.Image, {
        floated: cardInlinePhoto,
        size: cardInlinePhoto && imageSize,
        circular: imageCircular,
        src: image
      }), header && _react["default"].createElement(_semanticUiReact.Card.Header, {
        as: asLink ? 'a' : '',
        href: asLink ? link : '',
        textAlign: itemCenterContent ? 'center' : 'left'
      }, header, headerIcon), subheader && _react["default"].createElement(_semanticUiReact.Card.Meta, {
        textAlign: itemCenterContent ? 'center' : 'left'
      }, subheader), _react["default"].createElement("div", null, _react["default"].createElement(_semanticUiReact.Card.Description, {
        style: {
          marginTop: '0.5em'
        },
        textAlign: itemCenterContent ? 'center' : 'left'
      }, currentContent))), this.contentExceedsCharLimit() && _react["default"].createElement(_semanticUiReact.Card.Content, {
        textAlign: itemCenterContent ? 'center' : 'left',
        extra: true
      }, _react["default"].createElement(_semanticUiReact.Button, {
        color: buttonColor,
        fluid: true,
        primary: true,
        onClick: this.expandOrContractLongText,
        basic: buttonBasic,
        size: buttonSize
      }, buttonText)));
    }
  }, {
    key: "renderVerticalItem",
    value: function renderVerticalItem() {
      var _this$props4 = this.props,
          buttonSize = _this$props4.buttonSize,
          buttonBasic = _this$props4.buttonBasic,
          buttonColor = _this$props4.buttonColor,
          content = _this$props4.content,
          imageSize = _this$props4.imageSize,
          imageCircular = _this$props4.imageCircular,
          verticalItemAlign = _this$props4.verticalItemAlign,
          link = _this$props4.link,
          linkAs = _this$props4.linkAs,
          header = _this$props4.header,
          headerIcon = _this$props4.headerIcon,
          image = _this$props4.image,
          subheader = _this$props4.subheader;
      var _this$state2 = this.state,
          currentContent = _this$state2.currentContent,
          buttonText = _this$state2.buttonText;
      return _react["default"].createElement("div", null, image && _react["default"].createElement(_semanticUiReact.Image, {
        src: image,
        size: imageSize,
        circular: imageCircular,
        style: {
          margin: verticalItemAlign === 'center' ? '0 auto -1em auto' : '0',
          marginBottom: '-1em'
        }
      }), header && _react["default"].createElement(_semanticUiReact.Header, {
        icon: true,
        textAlign: verticalItemAlign
      }, _react["default"].createElement(_semanticUiReact.Header.Content, {
        style: {
          lineHeight: '1em'
        },
        as: linkAs === 'header' ? 'a' : 'h2',
        href: linkAs === 'header' ? link : ''
      }, header, headerIcon), subheader && _react["default"].createElement(_semanticUiReact.Header.Subheader, {
        style: {
          marginTop: '-0.1em'
        }
      }, subheader)), _react["default"].createElement("div", {
        style: {
          textAlign: verticalItemAlign
        }
      }, content && currentContent, this.contentExceedsCharLimit() && _react["default"].createElement("div", {
        style: {
          marginTop: '1em'
        }
      }, _react["default"].createElement(_semanticUiReact.Button, {
        color: buttonColor,
        primary: true,
        onClick: this.expandOrContractLongText,
        basic: buttonBasic,
        size: buttonSize
      }, buttonText))));
    }
  }, {
    key: "renderHorizontalItem",
    value: function renderHorizontalItem() {
      var _this$props5 = this.props,
          buttonSize = _this$props5.buttonSize,
          buttonColor = _this$props5.buttonColor,
          buttonBasic = _this$props5.buttonBasic,
          content = _this$props5.content,
          imageSize = _this$props5.imageSize,
          link = _this$props5.link,
          linkAs = _this$props5.linkAs,
          header = _this$props5.header,
          headerIcon = _this$props5.headerIcon,
          image = _this$props5.image,
          subheader = _this$props5.subheader,
          itemButtonFloat = _this$props5.itemButtonFloat,
          itemCenterContent = _this$props5.itemCenterContent;
      var _this$state3 = this.state,
          currentContent = _this$state3.currentContent,
          buttonText = _this$state3.buttonText;
      return _react["default"].createElement(_semanticUiReact.Item, null, image && _react["default"].createElement(_semanticUiReact.Item.Image, {
        size: imageSize,
        src: image
      }), _react["default"].createElement(_semanticUiReact.Item.Content, {
        verticalAlign: itemCenterContent ? 'middle' : 'top'
      }, header && _react["default"].createElement(_semanticUiReact.Item.Header, {
        as: linkAs === 'header' && link ? 'a' : '',
        href: linkAs === 'header' ? link : ''
      }, header, headerIcon), subheader && _react["default"].createElement(_semanticUiReact.Item.Meta, {
        style: {
          marginTop: '0.2em'
        }
      }, subheader), content && _react["default"].createElement(_semanticUiReact.Item.Description, {
        style: {
          marginTop: '0.7em'
        }
      }, currentContent), this.contentExceedsCharLimit() && _react["default"].createElement(_semanticUiReact.Item.Extra, null, _react["default"].createElement(_semanticUiReact.Button, {
        primary: true,
        color: buttonColor,
        floated: itemButtonFloat,
        onClick: this.expandOrContractLongText,
        basic: buttonBasic,
        size: buttonSize
      }, buttonText))));
    }
  }, {
    key: "render",
    value: function render() {
      var as = this.props.as;
      if (as === 'verticalItem') return this.renderVerticalItem();
      if (as === 'horizontalItem') return this.renderHorizontalItem();
      if (as === 'card') return this.renderCard();
      return _react["default"].createElement("div", null);
    }
  }]);
  return ItemElement;
}(_react["default"].Component);

exports["default"] = ItemElement;
ItemElement.propTypes = {
  header: _propTypes["default"].string.isRequired,
  as: _propTypes["default"].oneOf(['verticalItem', 'horizontalItem', 'card']),
  buttonBasic: _propTypes["default"].bool,
  buttonColor: _propTypes["default"].string,
  buttonSize: _propTypes["default"].string,
  cardInlinePhoto: _propTypes["default"].oneOf(['left', false]),
  charLimit: _propTypes["default"].number,
  content: _propTypes["default"].string,
  headerIcon: _propTypes["default"].element,
  image: _propTypes["default"].string,
  imageCircular: _propTypes["default"].bool,
  imageSize: _propTypes["default"].string,
  itemButtonFloat: _propTypes["default"].oneOf(['left', 'right']),
  itemCenterContent: _propTypes["default"].bool,
  link: _propTypes["default"].string,
  linkAs: _propTypes["default"].oneOf(['header', 'none']),
  subheader: _propTypes["default"].string,
  verticalItemAlign: _propTypes["default"].oneOf(['left', 'right', 'center'])
};
ItemElement.defaultProps = {
  as: 'horizontalItem',
  buttonColor: 'blue',
  buttonBasic: false,
  buttonSize: 'medium',
  cardInlinePhoto: false,
  charLimit: 150,
  content: '',
  headerIcon: null,
  image: '',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  link: '',
  linkAs: 'none',
  subheader: '',
  verticalItemAlign: 'center'
};
ItemElement.propOptions = {
  buttonColor: ['primary', 'secondary']
};